import { Component, OnInit, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { Auth } from 'aws-amplify';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ForgotPasswordComponent implements OnInit {

  resetForm: FormGroup;
  public errorMessage: string;
  public isLoading: boolean;
  public loggedIn: boolean;
  public recordfound: boolean;
  public returnUrl: string;
  public errorLogging: boolean;
  public noPwdMatch: boolean;
  public showForgotPwdField: boolean;
  public showForgotPwdSubmitField: boolean;
  public passwordResetSuccess: boolean;

  @Output() displayLoginHome: EventEmitter<boolean> = new EventEmitter(); 

  constructor(private formBuilder: FormBuilder, private router: Router, private route: ActivatedRoute) {
    this.resetForm = formBuilder.group({
      email: ['', [Validators.required]], 
      code: ['', Validators.required], 
      new_Pwd: ['', [Validators.required]], 
      conf_Pwd: ['', [Validators.required]], 
      username: ['', [Validators.required]]
    })
  }

  ngOnInit() {
    this.showForgotPwdField = true; 
  }

  onSubmitUsername() { 
    let required_username = this.resetForm.value.username; 
    Auth.forgotPassword(required_username)
      .then((data) => {
        console.log('Submitted Email => ', data); 
        this.showForgotPwdSubmitField = true
        this.showForgotPwdField = false; 
      })
      .catch((error) => {
        console.log('Submitted Email error => ', error);
      })

      console.log('This is the required username ==> ', required_username); 

  }

  onSubmitNewPassword() {
    let username = this.resetForm.value.email; 
    let code = this.resetForm.value.code; 
    let new_pwd = this.resetForm.value.new_Pwd;
    let confirm_newPwd = this.resetForm.value.conf_Pwd; 

    if(new_pwd === confirm_newPwd) {
      console.log('Username ', username);
      console.log('Code ', code);
      console.log('new_pwd ', new_pwd);
      console.log('confirm_newPWD', confirm_newPwd); 

      Auth.forgotPasswordSubmit(username, code, new_pwd)
      .then((data) => {
        console.log('New Password set ==> ', data); 
        this.passwordResetSuccess = true; 
        setTimeout(()=> {
          this.router.navigate(['/home'], { queryParams: { returnUrl: this.returnUrl }});  
        }, 3000)
      })
      .catch(err => {
        console.log('Setting new pwd error => ', err); 
      })
    }
    else {
      console.log('Passwords do not match!'); 
      this.noPwdMatch = true; 
      setTimeout(()=> {
        this.noPwdMatch = false; 
      }, 4000)
    }
  }

  // onCancel() {
  //   this.router.navigate(['/home']);
  //   this.displayLoginHome.emit(true); 
  // }


}
